<template>
  <div class="currency-input">
    <input
      ref="input"
      :value="valueWithCent"
      @input="updateValue($event.target.value)"
      @blur="onBlur"
      @focus="onFocus"
      @keyup.enter="onBlur"
    />
  </div>
</template>

<script src="./currency-input.js"></script>
<style src="./currency-input.scss" lang="scss"></style>
